module.exports = __webpack_public_path__ + "static/img/zh_HANT3.7be8dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/zh_HANT3.png
// module id = nIDr
// module chunks = 1